import Antd from 'ant-design-vue';
import { createApp } from 'vue';

import App from './App.vue';
import router from './router';
import store from './store';
import 'ant-design-vue/dist/reset.css';

import './styles/app.less';

createApp(App)
  .use(router)
  .use(store)
  .use(Antd)
  .mount('#app');
